import loadable from '@loadable/component';

export const OrgDashboardViewEventPageLoadable = loadable(
  () => import('./OrgDashboardViewEventPage'),
  {
    resolveComponent: (module) => module.OrgDashboardViewEventPage,
    ssr: false,
  },
);
